import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateDocument, privateDocumentsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getBinaryUploadModule } from '@/store/base/binary-uploads/module';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_DOCUMENT_MODULE = 'privatedocument';

const dataObjectModule = getDataObjectsModule<IPrivateDocument>(privateDocumentsManager, 5);
const searchModule = getSearchModule<IPrivateDocument>(privateDocumentsManager);
const binaryUploadModule = getBinaryUploadModule<IPrivateDocument>(privateDocumentsManager);

const privateDocumentModuleInstance = merge<unknown>(dataObjectModule, searchModule, binaryUploadModule, { actions });
store.registerModule(PRIVATE_DOCUMENT_MODULE, privateDocumentModuleInstance);

export { PRIVATE_DOCUMENT_MODULE };
